// extracted by mini-css-extract-plugin
export default {"questionMarkIcon":"_c740206a"};